import CalendarIcon from '@/public/images/dashboard/calendar.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export default function DoneEventsEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={CalendarIcon}
      title={Trans(translations, 'HereYouWillSeeTheEventsMade')}
    />
  );
}
